import React from 'react'
import { FaCheck } from 'react-icons/fa'
import cn from 'classnames'

import 'components/graph/controls/controls.less'

type SaveControlProps = {
  closeObjectDetails: (shouldSave: boolean) => void
  control: string
}

const SaveControl = ({ closeObjectDetails, control }: SaveControlProps) => {
  return (
    <div className={cn('control', 'save')} data-graph-type="control" title={`Save ${control}`}>
      <a className={cn('icon')} onClick={() => closeObjectDetails(true)}>
        <FaCheck aria-hidden />
        <span className="sr-only">Save</span>
      </a>
    </div>
  )
}

export default SaveControl
